import React, { ReactNode } from "react";
import { Field, ErrorMessage } from "formik";
import { useTranslation } from "react-i18next";

const FormikDropdown: React.FC<FormikDropdownProps> = ({
  label,
  isRequired,
  className,
  fieldName,
  children,
  disabled,
  ...props
}) => {
  const { t } = useTranslation();
  const requiredText = isRequired ? "*" : "";

  return (
    <>
      <label className="form-label">
        {`${t(label)}${requiredText}`}
      </label>

      <Field
        as="select"
        name={fieldName}
        className={`form-control ${className}`}
        disabled={disabled}
        {...props}
      >
        {children}
      </Field>

      <div className="text-danger">
        <ErrorMessage name={fieldName} component="div" />
      </div>
    </>
  );
}

export default FormikDropdown;

type FormikDropdownProps = {
  label: string;
  isRequired?: boolean;
  fieldName: string;
  placeholder?: string;
  className?: string;
  children: ReactNode | ReactNode[];
  disabled?: boolean;
} & React.ComponentProps<typeof Field>;

const defaultProps: Partial<FormikDropdownProps> = {
  isRequired: false,
  className: "",
  disabled: false
}

FormikDropdown.defaultProps = defaultProps;
